<template>
  <div class="bridge-list-container">
    <div class="page-header">
      <h2>桥梁列表</h2>
    </div>

    <el-card class="search-box">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="桥梁名称">
          <el-input v-model="searchForm.bridgeName" placeholder="请输入桥梁名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="桥梁类型">
          <el-select v-model="searchForm.bridgeType" placeholder="请选择桥梁类型" clearable>
            <el-option
              v-for="item in bridgeTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option :value="1" label="正常"></el-option>
            <el-option :value="0" label="异常"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchBridges">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-table
      v-loading="loading"
      :data="bridgeList"
      border
      stripe
      style="width: 100%; margin-top: 20px;">
      <el-table-column prop="bridgeName" label="桥梁名称" min-width="120"></el-table-column>
      <el-table-column prop="bridgeCode" label="编号" min-width="120"></el-table-column>
      <el-table-column prop="bridgeType" label="类型" min-width="100"></el-table-column>
      <el-table-column label="位置信息" min-width="180">
        <template slot-scope="scope">
          <div>经度：{{ formatLongitude(scope.row.longitude) }}</div>
          <div>纬度：{{ formatLatitude(scope.row.latitude) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="buildTime" label="建成时间" min-width="100"></el-table-column>
      <el-table-column prop="clearanceHeight" label="净空高度(m)" min-width="100"></el-table-column>
      <el-table-column prop="warningHeight" label="预警高度(m)" min-width="100"></el-table-column>
      <el-table-column prop="warningSpeed" label="预警速度(kn)" min-width="100"></el-table-column>
      <el-table-column label="状态" min-width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '正常' : '异常' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getBridgeList, deleteBridge } from '@/api/bridge'
import { formatLatitude, formatLongitude } from '@/utils/coordinate'

export default {
  name: 'BridgeList',
  inject: {
    registerNavButtons: {
      default: () => () => {}
    },
    unregisterNavButtons: {
      default: () => () => {}
    }
  },
  data() {
    return {
      loading: false,
      bridgeList: [],
      // 分页参数
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 搜索表单
      searchForm: {
        bridgeName: '',
        bridgeType: '',
        status: ''
      },
      // 桥梁类型选项
      bridgeTypeOptions: [
        { value: '斜拉桥', label: '斜拉桥' },
        { value: '悬索桥', label: '悬索桥' },
        { value: '拱桥', label: '拱桥' },
        { value: '梁桥', label: '梁桥' },
        { value: '钢架桥', label: '钢架桥' }
      ]
    };
  },
  created() {
    this.fetchBridgeList();
    
    // 注册导航按钮
    this.registerNavButtons([
      {
        id: 'add-bridge',
        text: '添加桥梁',
        icon: 'el-icon-plus',
        type: 'primary',
        handler: this.goToAddBridge
      }
    ]);
  },
  beforeDestroy() {
    // 在组件销毁前注销按钮
    this.unregisterNavButtons();
  },
  methods: {
    formatLatitude,
    formatLongitude,
    // 获取桥梁列表
    fetchBridgeList() {
      this.loading = true;
      
      // 构建查询参数
      const params = {
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        bridgeName: this.searchForm.bridgeName || undefined,
        bridgeType: this.searchForm.bridgeType || undefined,
        status: this.searchForm.status !== '' ? this.searchForm.status : undefined
      };
      
      getBridgeList(params)
        .then(response => {
          if (response && response.code === 200) {
            this.bridgeList = response.data.list || [];
            this.pagination.total = response.data.total || 0;
          } else {
            this.$message.error(response.message || '获取桥梁列表失败');
            this.bridgeList = [];
            this.pagination.total = 0;
          }
          this.loading = false;
        })
        .catch(error => {
          console.error('获取桥梁列表失败:', error);
          this.loading = false;
          this.bridgeList = [];
          this.pagination.total = 0;
        });
    },
    
    // 搜索桥梁
    searchBridges() {
      this.pagination.currentPage = 1;
      this.fetchBridgeList();
    },
    
    // 重置搜索条件
    resetSearch() {
      this.searchForm = {
        bridgeName: '',
        bridgeType: '',
        status: ''
      };
      this.searchBridges();
    },
    
    // 前往添加桥梁页面
    goToAddBridge() {
      this.$router.push('/bridge/management?actiontype=bridge-new&from=list');
    },
    
    // 编辑桥梁
    handleEdit(row) {
      this.$router.push(`/bridge/management?id=${row.id}&from=list`);
    },
    
    // 删除桥梁
    handleDelete(row) {
      this.$confirm('确认删除该桥梁?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBridge(row.id)
          .then(response => {
            if (response && response.code === 200) {
              this.$message.success('删除成功');
              this.fetchBridgeList();
            } else {
              this.$message.error(response.message || '删除失败');
            }
          })
          .catch(error => {
            console.error('删除失败:', error);
            this.$message.error('删除失败');
          });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    
    // 处理每页显示数量变化
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchBridgeList();
    },
    
    // 处理页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchBridgeList();
    }
  }
};
</script>

<style scoped>
.bridge-list-container {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-box {
  margin-bottom: 20px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.el-table {
  margin-top: 15px;
}
</style> 